import BaseEligibilityIndex from "../../common/controllers/BaseEligibilityIndex";

export default class ExtranetEligibilityIndex extends BaseEligibilityIndex {

    constructor() {
        super();
        this.toggleTestModal();
    }

    toggleTestModal(){
        if(application.getParam("modal_test") === "true"){
            $("#test_modal").modal("show")
        }
    }
}